<template>
  <div class="imsuccessApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide games" >
        <a href=""><img :src="baseUrl+setScenic.img"></a>
      </swiper-slide>
    </swiper>
    <div class="cont">
      <div class="info">
        <h2 class="title"><div>{{setScenic.title}}</div>
          <span class="curt">{{setScenic.level}}级景区</span>
          <span>{{setScenic.read_num}}次查阅</span>
        </h2>
        <h2>景区地址：{{setScenic.address}}</h2>
        <h2 style="padding-bottom:10px">
          <p>周一至周日</p>
          <p>入场时间：{{setScenic.business}}</p>
          <p></p>
          <p>以上信息仅供参考，具体以景区当日实际公示信息为准。</p>
        </h2>
        <h2 class="box">您的票务要求
          <div class="right"><font>{{setScenic.content}}</font><i class="el-icon-arrow-right"></i></div>
        </h2>
        <h2 class="box" v-if="setScenic.types == 2">您的取票码
          <div class="right"><font>{{setScenic.status == 1 ? '申请中' : setScenic.code}}</font><i class="el-icon-arrow-right"></i></div>
        </h2>

        <h2 class="box" @click="previewImage" v-if="setScenic.types == 1">您的取票码
          <div class="right"><font>{{setScenic.status == 1 ? '申请中' : '取票码已生成，点击查看'}}</font><i class="el-icon-arrow-right"></i></div>
        </h2>

        <div class="goDetail" @click="toPush(setScenic.scenic_id,'tkscenic')">详情<i class="el-icon-arrow-right"></i></div>
      </div>
    </div>



  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        setScenic:[],
        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 1000 //自自动循环时间
          }, //可选选项，自动滑动
          initialSlide: 0,
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:false, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/imsuccess?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getScenic();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      previewImage:function(e){
        if(this.setScenic.status == 1){
          return false;
        }
        var img = this.setScenic.code
          img = 'http://admin.4008005216.com/'+img
        wx.previewImage({
          current: img,
          urls: [img] // 需要预览的图片http链接列表
        });
      },
      getScenic:function(e){
        var that = this;
        var id = that.$route.query.id;
        this.axios({
          'url': that.$host+'home/ticket/bill',
          'method': 'post',
          params:{
            id:id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setScenic = res;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },


      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-dialog{
    width:90% !important;
    border-radius:6px;
  }
  .el-dialog__body{
    padding:20px 20px 0 20px !important;
  }
  .el-form-item__content{
    margin-left:0 !important
  }
  .el-form-item__label{
    text-align:left
  }
  .imsuccessApp{
    max-width:640px;
    background:#f1f1f1;
    margin:0 auto;
  }
  .imsuccessApp .swiper-slide{
    width:100%
  }
  .imsuccessApp .swiper-slide img{
    display:block;
    width:100%;
  }
  .imsuccessApp .cont{
    width:94%;
    display:block;
    margin:0 auto;
    z-index:99;
    position:relative;
    top:-60px;
  }
  .imsuccessApp .info{
    width:100%;
    display:block;
    position:relative;
    background:#fff;
    border-radius:6px;
  }
  .imsuccessApp .info .goDetail{
    position:absolute;
    right:3%;
    transform: translateY(-50%);
    top:15%;
    font-size:14px;
    color:#666
  }
  .imsuccessApp .info h2{
    font-size:15px;
    padding-top:10px;
    width:92%;
    display:block;
    margin:0 auto;
    font-weight:normal;
    color:#333;
  }
  .imsuccessApp .info h2.box{
    border-top:solid 1px #f5f5f5;
    padding:18px 0;
    color:#666
  }
  .imsuccessApp .info h2 .right{
    float:right;
    width:60%;
    text-align:right
  }
  .imsuccessApp .info h2 .right font{
    color:#ff5555;
    float:left;
    width:90%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .imsuccessApp .info h2 textarea{
    outline:none;
    border:solid 1px #ececec;
    font-size:15px;
    width:96%;
    color:#666;
    height:70px;
    background:#fff;
    border-radius:5px;
    padding:5px 2%;
    margin-top:8px;
    resize: none
  }
  .imsuccessApp .info h2 .right i{
    float:right;
    margin-top:2px
  }
  .imsuccessApp .info h2 p{
    padding-bottom:5px;
    line-height:22px
  }
  .imsuccessApp .info h2.title{
    color:#000;
    font-weight:bold;
    font-size:16px;
    padding:15px 0 12px 0
  }
  .imsuccessApp .info h2.title div{
    margin-bottom:8px
  }
  .imsuccessApp .info h2.title span{
    font-weight:normal;
    display:inlie-block;
    border:solid 1px #F56C6C;
    font-size:12px;
    padding:3px 5px;
    border-radius: 4px;
    color:#F56C6C;
    margin-right:8px;
  }
  .imsuccessApp .info h2.title span.curt{
    color:#67C23A;
    border-color:#67C23A
  }
  .imsuccessApp .info h2 a{
    color:#2F78FF;
    text-decoration: none;
  }
</style>